import { ajaxGet, get, post } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';
import { translate } from '../../Services/translation';

export const ONLINE_CATALOG_SET_PAGES = "ONLINE_CATALOG_SET_PAGES";
export const ONLINE_CATALOG_SET_LEFT_PAGE = "ONLINE_CATALOG_SET_LEFT_PAGE";
export const ONLINE_CATALOG_SET_RIGHT_PAGE = "ONLINE_CATALOG_SET_RIGHT_PAGE";
export const ONLINE_CATALOG_TOGGLE_MODAL_MESSAGE = "ONLINE_CATALOG_TOGGLE_MODAL_MESSAGE";
export const ONLINE_CATALOG_SET_BROWSE_STATUS = "ONLINE_CATALOG_SET_BROWSE_STATUS";
export const ONLINE_CATALOG_ERROR = "ONLINE_CATALOG_ERROR";
export const ONLINE_CATALOG_SET_PAGES_LOADED = "ONLINE_CATALOG_SET_PAGES_LOADED";

export const downloadCatalog = () => (dispatch, getState) => {
    return get('/api/onlineCatalog/download')
        .then(response => response.json())
        .then(response => dispatch(toggleModalMessage(response, true)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

//Will return list of urls to all pages in cataog
//so we can just move along the list
export const getCatalog = () => (dispatch, getState) => {
    return get('/api/onlineCatalog')
        .then(response => response.json())
        .then(response => {
            const urlParams = new URLSearchParams(window.location.search);
            let pageNumber = urlParams.get('page');
            if (!pageNumber || pageNumber.length === 0) {
                pageNumber = 1;
            }
            else {
                pageNumber = parseInt(pageNumber);
            }
            const spreadWidthLimit = getState().onlineCatalog.spreadWidthLimit;
            if (window.innerWidth > spreadWidthLimit && pageNumber % 2 === 0)
                pageNumber -= 1;
            dispatch(onlineCatalog(response, pageNumber));
        })

        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

function setUrl(page) {
    const url = window.location.href.replace(window.location.search, '') + '?page=' + page;
    window.history.pushState('catalog', 'Catalog', url);
}

export const previousSpread = (spreadSize) => (dispatch, getState) => {
    const currentRightPage = getState().onlineCatalog.currentPage - spreadSize;
    if (currentRightPage < 1)
        return;
    const pages = getState().onlineCatalog.pages;
    dispatch(setBrowseStatus(false));
    setUrl(currentRightPage);
    dispatch(getCatalogSpread(currentRightPage,
        pages[currentRightPage - 1],
        spreadSize > 1 ? pages[currentRightPage] : null));
}

export const nextSpread = (spreadSize) => (dispatch, getState) => {
    const currentRightPage = getState().onlineCatalog.currentPage + spreadSize;
    const pages = getState().onlineCatalog.pages;
    if (currentRightPage > pages.length) {
        return;
    }

    dispatch(setBrowseStatus(true));

    setUrl(currentRightPage);
    dispatch(getCatalogSpread(currentRightPage,
        pages[currentRightPage - 1],
        spreadSize > 1 ? pages[currentRightPage] : null));
}

export const goToPage = (spreadSize, pageNo) => (dispatch, getState) => {
    let currentRightPage = pageNo;
    if (spreadSize === 2) {
        if ((pageNo % 2) == 0) {
            currentRightPage--;
        }
    }

    const pages = getState().onlineCatalog.pages;
    if (currentRightPage > pages.length) {
        return;
    }

    setUrl(currentRightPage);
    dispatch(getCatalogSpread(currentRightPage,
        pages[currentRightPage - 1],
        spreadSize > 1 ? pages[currentRightPage] : null));
}

export const getPage = (pageNumber, spreadSize, event) => (dispatch, getState) => {
    // run if user hits enter
    if (event.keyCode === 13 || event.type == 'change') {
        const page = parseInt(pageNumber);
        const pages = getState().onlineCatalog.pages;
        if (pageNumber.length == 0 || page > pages.length || page < 1)
            return;
        setUrl(page);

        if (page % 2 === 0)
            dispatch(getCatalogSpread(spreadSize > 1 ? page - 1 : page,
                pages[page - spreadSize],
                spreadSize > 1 ? pages[page - 1] : null));
        else
            dispatch(getCatalogSpread(page, pages[page - 1], spreadSize > 1 ? pages[page] : null));
    }
}

export const getCatalogSpread = (currentPage, leftPageUrl, rightPageUrl) => (dispatch, getState) => {
    dispatch({
        type: ONLINE_CATALOG_SET_PAGES_LOADED,
        payload: {
            rightPageSet: false,
            leftPageSet: false
        }
    });
    if (rightPageUrl != null) {
        //Get the left page and dispatch it
        ajaxGet(leftPageUrl).then(response => response.text())
            .then(htmlLeftPage => {
                ajaxGet(rightPageUrl).then(response => response.text())
                    .then(htmlRightPage => {
                        dispatch(setRightPage(currentPage, htmlRightPage));
                        dispatch(setLeftPage(currentPage, htmlLeftPage));
                    })
            })
    }
    else {
        ajaxGet(leftPageUrl).then(response => response.text())
            .then(htmlLeftPage => {
                dispatch(setLeftPage(currentPage, htmlLeftPage));
                dispatch(setRightPage(currentPage, "<p></p>"));
            })
    }
}

export const toggleModalMessage = (message, isOpen) => (dispatch, getState) => {
    dispatch({
        type: ONLINE_CATALOG_TOGGLE_MODAL_MESSAGE,
        payload: {
            modalMessage: message,
            showModal: isOpen
        }
    });
}

export const setRightPage = (currentPage, html) => (dispatch, getState) => {
    dispatch({
        type: ONLINE_CATALOG_SET_RIGHT_PAGE,
        payload: {
            currentPage: currentPage,
            rightPageHtml: html
        }
    });
    dispatch({
        type: ONLINE_CATALOG_SET_PAGES_LOADED,
        payload: {
            rightPageSet: true
        }
    });
}

export const setLeftPage = (currentPage, html) => (dispatch, getState) => {
    dispatch({
        type: ONLINE_CATALOG_SET_LEFT_PAGE,
        payload: {
            currentPage: currentPage,
            leftPageHtml: html

        }
    });
    dispatch({
        type: ONLINE_CATALOG_SET_PAGES_LOADED,
        payload: {
            leftPageSet: true
        }
    });
}

export const setBrowseStatus = (isRightBrowse) => (dispatch, getState) => {
    const pageFlipClass = (isRightBrowse ? 'online-catalog--right-browsing' : 'online-catalog--left-browsing');

    dispatch({
        type: ONLINE_CATALOG_SET_BROWSE_STATUS,
        payload: {
            pageFlipClass: '',
        }
    });

    setTimeout(() => {
        dispatch({
            type: ONLINE_CATALOG_SET_BROWSE_STATUS,
            payload: {
                pageFlipClass,
            }
        });
    }, 100);
}

export const onlineCatalog = (catalog, pageNumber) => (dispatch, getState) => {
    dispatch({
        type: ONLINE_CATALOG_SET_PAGES,
        payload: {
            pages: catalog.pageUrls,
            tableOfContents: catalog.tableOfContents,
            currentPage: pageNumber,
        }
    });
    dispatch(getCatalogSpread(pageNumber, catalog.pageUrls[pageNumber - 1], catalog.pageUrls[pageNumber]));
}

export const setError = error => ({
    type: ONLINE_CATALOG_ERROR,
    payload: {
        error,
    },
})